<div role="document" class="modal-dialog">
  <div class="modal-content">
    <form name="editForm" role="form" novalidate [formGroup]="offreCreateForm"
      #f="ngForm">

    <div class="modal-header">
            <h5 class="modal-title">Annoncer une offre </h5>
        </div>
        <div class="modal-body">
            <div class=" row">
                <span class="col p-2">
                  <label class="w-auto">Note</label>
                  <div class="form-row mb-2">
                    <textarea type="text" class="form-control" id="offer" row="10" name="offer"
                    [ngClass]="{ 'forminput-invalid':
                    f.submitted && offreCreateForm?.controls?.offer?.errors != null}" formControlName="offer" >
                    </textarea>
                    <div *ngIf="f.submitted && offreCreateForm?.controls?.offer?.errors" class="text-danger">
                      champ Obligatoire
                    </div>
                  </div>
                </span>
            </div>
            <div class=" row">
              <div class="col p-2">
                <label class="form-control-label" for="adresse">Temps Stationnement offert  : </label>
                  <div class="col-6">
                    <ngb-timepicker class="mb-2" formControlName="timeParkFree"></ngb-timepicker>
                  </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-indigo" (click)="validate()">Valider</button>
            <button type="button" class="btn btn-secondary"
                    data-dismiss="modal" (click)="activeModal.close()">Annuler
            </button>
        </div>
      </form>
      </div>
  </div>
